module.exports = __webpack_public_path__ + "static/media/sub_meal02.59372e37.png";